import { FilterPartialExpression } from '../typings/filter';
import { PeriodFilterValue } from '../typings/filters';
import { LogNavEntityParams } from '../typings/log';

export const LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE = 'LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE';
export type LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE = typeof LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE;

export interface LogNavigationGoToFilterWithCidRemoveAction {
    type: LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE;
    expressions: FilterPartialExpression[];
}

export function navToFilterWithCidRemove(
    expressions: FilterPartialExpression[]
): LogNavigationGoToFilterWithCidRemoveAction {
    return {
        type: LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE,
        expressions
    };
}

export const LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL = 'LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL';
export type LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL = typeof LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL;

export interface LogNavigationGoToLogPeriodUrlAction {
    type: LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL;
    period: PeriodFilterValue;
}

export function navToLogPeriodUrl(period: PeriodFilterValue): LogNavigationGoToLogPeriodUrlAction {
    return {
        type: LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL,
        period
    };
}

export const LOG_NAVIGATION_GO_TO_ENTITY = 'LOG_NAVIGATION_GO_TO_ENTITY';
export type LOG_NAVIGATION_GO_TO_ENTITY = typeof LOG_NAVIGATION_GO_TO_ENTITY;

export interface LogNavigationGoToEntityAction {
    type: LOG_NAVIGATION_GO_TO_ENTITY;
    params: LogNavEntityParams;
}

export function navToEntity(params: LogNavEntityParams): LogNavigationGoToEntityAction {
    return {
        type: LOG_NAVIGATION_GO_TO_ENTITY,
        params
    };
}

export type LogNavigationAction =
    | LogNavigationGoToFilterWithCidRemoveAction
    | LogNavigationGoToLogPeriodUrlAction
    | LogNavigationGoToEntityAction;
